module.exports = __webpack_public_path__ + "img/shape11.e0531302.png";